module.exports = __webpack_public_path__ + "static/media/photographycarry03.75231685.png";